import React from 'react';
import useExperience from '../../../../hooks/useExperience';
import { Language } from 'src/types/Language';
import { spacing } from '@digitools/honest-ui';
const ContentBlocks = () => {
    const { language } = useExperience();
    return (<>
      {/* Spanish translation disclaimer */}
      {language !== Language.ENGLISH &&
            <div style={{ marginTop: spacing.lg }}>
        Esta es una traducción de una comunicación escrita originalmente en inglés.
        Esta comunicación tiene fines informativos únicamente, y la versión en inglés de esta comunicación es la versión oficial para fines de aplicación e interpretación.
        En caso de disputa entre las versiones en inglés y en otros idiomas de esta comunicación, prevalecerá la versión en inglés.
        Además, nos reservamos el derecho de corregir cualquier error en este documento en todos los estados excepto Florida.
      </div>}
    </>);
};
export default ContentBlocks;
